import { render, staticRenderFns } from "./OrderUserIdEditDialog.vue?vue&type=template&id=0d535101&scoped=true"
import script from "./OrderUserIdEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderUserIdEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderUserIdEditDialog.vue?vue&type=style&index=0&id=0d535101&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d535101",
  null
  
)

export default component.exports